import { QuestionClusteringStatusSlice } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusSlice'
import { DateObject } from 'tabs/topQuestions/utils/DateUtils'
import { ClusteringStatus } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'

export const selectQuestionClusteringRequests = (root: any) => {
  const executionStatusSlice: QuestionClusteringStatusSlice = root.questionClusteringStatusSlice
  return executionStatusSlice.beginClusteringRequest
}

export const selectStartDateFilter = (root: any): DateObject | undefined => {
  const lineChartState: QuestionClusteringStatusSlice = root.questionClusteringStatusSlice
  return lineChartState.lienChartFilter.startDate
}
export const selectEndDateFilter = (root: any): DateObject | undefined => {
  const lineChartState: QuestionClusteringStatusSlice = root.questionClusteringStatusSlice
  return lineChartState.lienChartFilter.endDate
}

export const selectIsClustering = (executionId: string | undefined) => (root: any) => {
  if (executionId != undefined) {
    const lineChartState: QuestionClusteringStatusSlice = root.questionClusteringStatusSlice
    const trainingCluster = lineChartState.trainingClusters[executionId]
    return trainingCluster || { status: ClusteringStatus.NEW, n: 0 }
  } else {
    return { status: ClusteringStatus.NEW, n: 0 }
  }
}
